import Styles from './styles.module.css';
import React from 'react';
import { MdMenuBook } from "react-icons/md";
import { HiOutlineDocumentText } from "react-icons/hi";
import { HiNewspaper } from "react-icons/hi2";
import DefaultImage from "./../../../image/default/home.png";

type SchoolItemProps = {
  data: any;
  setToggle: React.Dispatch<React.SetStateAction<any>>;
};

const SchoolItem: React.FC<SchoolItemProps> = ({ data, setToggle }) => {

  return (
    <>
    <div className={Styles.table}>
      <h4 className={Styles.number}>{data.no}</h4>
      <img className={Styles.image} alt=""
        src={`https://firebasestorage.googleapis.com/v0/b/trankllc-com.appspot.com/o/companies_logo%2Fresize_images%2F${data.companyId}_200x200?alt=media&token=?0`}
        onError={(e) => e.currentTarget.src = DefaultImage} />
      <h2 className={Styles.name}>{data.name}</h2>
      
      <div style={{ flex: "1", alignItems: "center" }}></div>

      <div className={Styles.items}>
        {data.pv}件
      </div>
      <div className={Styles.items}>
        {data.visits}件
      </div>
      <div className={Styles.items}>
        {data.favorite}件
      </div>
      <div className={Styles.items}>
        {data.apply}件
      </div>
      <div className={Styles.items}>
        {data.offer}件
      </div>
      <div className={Styles.items}>
        {data.decline}件
      </div>
      <div className={Styles.items}>
        {data.rejected}件
      </div>

      <HiOutlineDocumentText className={Styles.icon} style={data.jobPostingsStatus ? {} : {color: "#EBEBEB"}}
        onClick={() => {
          if (data.jobPostingsStatus) {
            setToggle({ type: "jobPosting", id: data.id, name: data.name })
          }}} />

      <a href={data.pamphlet ? `https://firebasestorage.googleapis.com/v0/b/trankllc-com.appspot.com/o/pamphlet%2F${data.id}?alt=media&token=` : undefined}
        onClick={(e) => { if (!(data.pamphlet)) { e.preventDefault(); } }}
        target="_blank" rel="noopener noreferrer">
        <MdMenuBook className={Styles.icon}  style={data.pamphlet ? {} : {color: "#EBEBEB"}} />
      </a>

      <a href={data.recruitStatus || data.jobPostingsStatus ? `https://memorii-works.com/recruit/id=${data.id}` : undefined}
        onClick={(e) => { if (!(data.recruitStatus || data.jobPostingsStatus)) { e.preventDefault(); } }}
        target="_blank" rel="noopener noreferrer">
        <HiNewspaper className={Styles.icon} style={data.recruitStatus || data.jobPostingsStatus ? {} : {color: "#EBEBEB"}} />
      </a>
    </div>
    </>
  );
}

export default SchoolItem;
